import clsx from "clsx";
import { FC } from "react";
import { CopyToClipboard, NoData } from "../../../../../../components";
import { Sizes } from "../../../../../../components/Icon";

type Props = {
  value?: string | null;
  reverse?: boolean;
  size?: Sizes;
};

const StringWithCopy: FC<Props> = ({ value, reverse, size = 14, children }) => {
  if (!value) return <NoData />;

  return (
    <div className="flex flex-gap-1 m-left-1 overflow-ellipsis k-pdf-hash-info-item">
      <CopyToClipboard
        containerClassName={clsx("flex", `flex-order-${reverse ? 1 : 0}`)}
        className="k-pdf-hide-in-pdf"
        value={value}
        size={size}
      />
      <div
        className={clsx("overflow-ellipsis", `flex-order-${reverse ? 0 : 1}`)}
        data-testid="report_summary_hash_value"
      >
        {children ?? value}
      </div>
    </div>
  );
};

export default StringWithCopy;
